// extracted by mini-css-extract-plugin
export default {"container":"CardImage-module__container-ik_p_L","image":"CardImage-module__image-oxLmjv","fixedHeight":"CardImage-module__fixedHeight-X6PH6z"};